import { httpClient } from '@shared/api'
import type { AdCampaign, AdCampaignDTO } from '../model/types'
import { mapAdCampaignFromDTO, mapAdCampaignToDTO } from './mappers'
import type { AdCampaignType, CreateAdCampaignArgs, DeleteAdCampaignArgs, EditAdCampaignArgs } from './types'

export const getAdCampaigns = async (type?: AdCampaignType, channelId?: number): Promise<AdCampaign[]> => {
    const { data: result } = await httpClient.get<AdCampaignDTO[]>('/advertising-campaigns', {
        params: { channel_id: channelId, type }
    })
    return result.map(mapAdCampaignFromDTO)
}

export const createAdCampaign = async (data: CreateAdCampaignArgs): Promise<AdCampaign> => {
    const { data: result } = await httpClient.post<AdCampaignDTO>('/advertising-campaigns', mapAdCampaignToDTO(data))
    return mapAdCampaignFromDTO(result)
}

export const editAdCampaign = async ({ id, data }: EditAdCampaignArgs): Promise<AdCampaign> => {
    const { data: result } = await httpClient.patch<AdCampaignDTO>(
        `/advertising-campaigns/${id}`,
        mapAdCampaignToDTO(data)
    )
    return mapAdCampaignFromDTO(result)
}

export const deletAdCampaign = async ({ id }: DeleteAdCampaignArgs): Promise<void> => {
    await httpClient.delete<AdCampaignDTO>(`/advertising-campaigns/${id}`)
}
